// src/lib/accountLadder.js — the account type/status ladder, for the frontend.
//
// WHY THIS FILE EXISTS (P0.31 task 31.A.2)
// `accounts.status` is only meaningful against `accounts.account_type`: a
// Customer has eight legal statuses, a Competitor two, and they barely overlap.
// The authority is ACCOUNT_STATUS_BY_TYPE in api/shared/import-schema.js, which
// the importer enforces. The CRA build CANNOT import from api/, so the
// frontend needs its own copy. That duplication is structural, not laziness.
//
// It previously lived as a `const STATUS_OPTIONS` inside AccountsListPage.jsx.
// P0.31 needs the same map in AccountDetailPage, to offer a legal status when an
// account's TYPE changes, and a second in-component copy would have made three.
// tests/account-status-ladder.test.js holds this file and the importer in step.
//
// THE DEFECT THIS EXISTS TO STOP. AccountDetailPage's edit form hardcoded the
// eight CUSTOMER statuses for every account, so a Competitor's form offered
// "Closed Won" and six others its type cannot hold — and nothing in the database
// prevents the write. Measured in production on 24 Oct 2026: three accounts
// already held an illegal pair (2 Vendors and 1 Competitor at "Under Review"),
// which is how 10 of one tenant's 25 accounts arrived unimportable in October.

export const STATUS_OPTIONS = {
  'Customer': ['Targeted','Under Review','Engaged','Active','Stalled','Closed Won','Closed Tabled by Client','Closed Lost to Competitor'],
  'Competitor': ['Active','Inactive'],
  'Vendor': ['Active Partner','Evaluating','Inactive'],
  'Partner': ['Active Partner','Prospecting','Inactive'],
};

/** The four relationship shapes an account can have. */
export const ACCOUNT_TYPES = Object.keys(STATUS_OPTIONS);

/**
 * The statuses legal for a type. An unknown type yields the UNION rather than
 * an empty list: a row carrying a type we do not recognise should not have its
 * status silently emptied by an edit form.
 */
export function statusesFor(accountType) {
  return STATUS_OPTIONS[accountType]
    || [...new Set(Object.values(STATUS_OPTIONS).flat())];
}

/** Is this status legal for this type? An unknown type accepts anything. */
export function isLegalStatus(accountType, status) {
  if (!status) return true;                       // empty is not illegal, just unset
  if (!STATUS_OPTIONS[accountType]) return true;  // see statusesFor
  return STATUS_OPTIONS[accountType].includes(status);
}
